import React, {useEffect, useState} from "react";
import {
	Button, Checkbox,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	FormControlLabel
} from "@mui/material";
import FunctionsData from "../Functions/FunctionsData";

export default function ShowConfirmationDialog(props) {
	
	let header = props.header || "Do you really want to delete this?";
	let txt = <>Deleting this will remove the selected item and all of it's related information. <span style={{color:'red'}}>You will not be able to undo this.</span></>
	const [selectedOption,setSelectedOption]  = useState('');
	const [textConfirm,setTextConfirm]  = useState(<h5></h5>);
	const [frm,setFrm]  = useState('');
	const option = [
		'I confirm'
	];
	
	useEffect(() => {
		let d = Math.floor(Math.random() * 4) + 1;
		if(props.textConfirmSet) {
			setSelectedOption(props.textConfirmSet || 'dsf');
		}else{
			setSelectedOption(option[d] || option[0]);
		}
	}, []);
	
	useEffect(() => {
		if(props.textConfirm) {
			setTextConfirm(<h5>{props.textConfirm}</h5>)
		}else{
			setTextConfirm(<h5>Please verify your decision by typing {selectedOption}. </h5>)
		}
	}, [selectedOption]);
	
	function handleClose() {
		// props.setOpen(false);
		window.location.href="/";
	}
	
	if(props.create === true && props.header) {
		txt = props.desc || <>You are creating a new section. Are you sure?</>;
		header = props.header;
	}
	
	if(props.create === true && !props.header) {
		txt = <>You are creating a new section. Are you sure?</>;
		header = "Adding content";
	}
	
	if(props.message) {
		txt = props.message;
	}
	
	return (
		<Dialog
			open={props.open}
			// onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown
			disableBackdropClick
		>
			{
				(header !== 'X') ?
					<DialogTitle id="alert-dialog-title">
						{header}
					</DialogTitle>
					: undefined
			}
			<DialogContent>
				<DialogContentText id="alert-dialog-description">
					{txt}
				</DialogContentText>
				{
					(props.checkboxAccept === false && props.confirm && selectedOption !== '') ?
						<div style={{margin:'20px 0', width:'calc(100% - 25px)'}}>
							{textConfirm}
							<input className={"form-control-search"}
							       style={{padding:5}}
							       placeholder={selectedOption}
							       value={frm}
							       onChange={(e) => setFrm(e.target.value)} />
						</div>
						: undefined
				}
				{
					(props.checkboxAccept === true) ?
						<div style={{margin:'0 20px'}}>
							<FormControlLabel control={<Checkbox checked={(frm === selectedOption)} onChange={(e) => {
								if(e.currentTarget.checked === true) {
									setFrm(selectedOption)
								}else{
									setFrm('')
								}
							}
							} />} label={textConfirm} />
						</div>
						: undefined
				}
			</DialogContent>
			<DialogActions>
				
				<Button onClick={() => {
					if(props.setFrmSource) props.setFrmSource(null);
					props.setOpen(false)
				}}>Cancel</Button>
				<Button onClick={() => {
					
					if(props.checkboxAccept) {
					
						FunctionsData.postData(
							'/api/voucher/consent/'+props.frmSn,
							{
								email:props.frmEmail,
								category:props.frmSource
							}
						).then((r) => props.setOpen(false))
					
					}
				}} disabled={(props.confirm === true && frm.toLowerCase().trim() !== selectedOption.toLowerCase())}
				        autoFocus>
					Confirm
				</Button>
			</DialogActions>
		</Dialog>
	)
	
}